import { useScroll } from 'ahooks';
import React from 'react';
import usePortal from 'react-cool-portal';
import { Box, getVariant } from '@apia/theme';
import { useMenu } from '../menuController';
import { getLabel, useMatchScrollDirection } from '@apia/util';
import { AccordionItem } from '../../components';

/**
 * Aside del template twoColumns. Breakpoints: 0,1,2.
 *
 * Este aside es el que aparece cuando el usuario hizo scroll
 * en la vista responsiva, y luego hizo scroll hacia arriba.
 */

export const FloatingAside = () => {
  const isScrollingUp = useMatchScrollDirection('up');
  const [hasScrolledEnough, setHasScrolledEnough] = React.useState(false);

  useScroll(document, ({ top }) => {
    const menu = document.getElementById('BodyAside') as HTMLDivElement;
    if (!menu) return false;

    let computedStyle = 0;
    if (window.getComputedStyle(menu).paddingTop.match(/\d+/)) {
      computedStyle =
        Number(
          (
            window.getComputedStyle(menu).paddingTop.match(/\d+/) as [string]
          )[0],
        ) +
        Number(
          (
            window.getComputedStyle(menu).paddingBottom.match(/\d+/) as string[]
          )[0],
        );
    }

    const boxTop = menu.offsetHeight + menu.offsetTop + computedStyle;

    if (hasScrolledEnough !== boxTop < top) setHasScrolledEnough(boxTop < top);

    return false;
  });

  const children = useMenu([1, 2, 3]);

  const { Portal } = usePortal({
    containerId: 'NonControlledAppModals',
    clickOutsideToHide: false,
    autoRemoveContainer: false,
    defaultShow: true,
    escToHide: false,
  });

  if (!children) return null;

  return (
    <Portal>
      <Box
        {...getVariant('layout.twoColumnsAside.floatingResponsive')}
        className={isScrollingUp && hasScrolledEnough ? '' : 'hidden'}
      >
        <AccordionItem
          defaultExpanded={false}
          buttonProps={{
            label: getLabel('lblMnuOpc').text,
            ariaLabel: getLabel('lblMnuOpc').title,
          }}
          id="floatingMenuAccordion"
          {...getVariant('tabPrimary')}
        >
          {isScrollingUp && hasScrolledEnough && children}
        </AccordionItem>
      </Box>
    </Portal>
  );
};
